import { RevisionFlowStatus } from '#components/revision-flow-status/revision-flow-status.js';

import type { BuildAutomationMode, RevisionStatus } from '@cadstrom/cadstrom-shared';

export interface ProjectStatusIndicatorProps {
	status: RevisionStatus | undefined;
	/** Distinguishes a revision awaiting an upload from one already queued. */
	hasUploadedFiles: boolean;
	/** Distinguishes an analysis gate waiting on a person from one under automation. */
	automationMode?: BuildAutomationMode;
	/** Whether the organization is on the billing flow, which decides who clears the analysis gate. */
	showBillingFlow: boolean;
}

/**
 * A project's latest revision as its position in the pipeline. Statuses where
 * Cadstrom is executing work pulse the dot; a project with no revisions shows a
 * neutral "No revisions yet".
 */
export function ProjectStatusIndicator({
	status,
	hasUploadedFiles,
	automationMode,
	showBillingFlow,
}: ProjectStatusIndicatorProps) {
	if (status === undefined) {
		return (
			<span className='flex items-center gap-1.5 text-sm whitespace-nowrap text-gray-a10'>
				<span className='h-2 w-2 shrink-0 rounded-full bg-gray-a7' />
				No revisions yet
			</span>
		);
	}

	return (
		<RevisionFlowStatus
			status={status}
			hasUploadedFiles={hasUploadedFiles}
			automationMode={automationMode}
			showBillingFlow={showBillingFlow}
			pulseWhenRunning
			className='text-sm'
		/>
	);
}
